export const GLOBAL_CTAS_WHATS_IN_A_MEMBERSHIP_FLAG_NAME = 'pen-5087_v1'
